import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import AnalyticsCard from './AnalyticsCard';

const rateColor = (r) => (r >= 70 ? '#ef4444' : r >= 50 ? '#f97316' : '#f59e0b');

export default function FailureAnalysis({ data }) {
  return (
    <AnalyticsCard title="Failure Rate by Make (≥30 claims)">
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={data} layout="vertical" margin={{ top: 0, right: 32, left: 4, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e5e7eb" />
          <XAxis type="number" domain={[0, 100]} tick={{ fontSize: 10, fill: '#7e848c' }} tickFormatter={(v) => `${v}%`} />
          <YAxis dataKey="make" type="category" tick={{ fontSize: 10, fill: '#1e2125' }} width={80} />
          <Tooltip formatter={(v, n, p) => [`${v}% (${p.payload.failed}/${p.payload.total})`, 'Fail Rate']} />
          <Bar dataKey="failRate" name="Failure Rate" radius={[0, 3, 3, 0]}>
            {data.map((d, i) => <Cell key={i} fill={rateColor(d.failRate)} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="flex gap-3 mt-2 text-xs text-text-secondary">
        <span className="flex items-center gap-1">
          <span className="w-2 h-2 rounded-full inline-block" style={{ background: '#ef4444' }} />≥70%
        </span>
        <span className="flex items-center gap-1">
          <span className="w-2 h-2 rounded-full inline-block" style={{ background: '#f97316' }} />50–70%
        </span>
        <span className="flex items-center gap-1">
          <span className="w-2 h-2 rounded-full inline-block" style={{ background: '#f59e0b' }} />&lt;50%
        </span>
      </div>
    </AnalyticsCard>
  );
}
